import { render, staticRenderFns } from "./TempBaseForm.vue?vue&type=template&id=a5c78c80"
import script from "./TempBaseForm.vue?vue&type=script&lang=js"
export * from "./TempBaseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports